import { Award, ShieldCheck, Truck } from "lucide-react";
const trustSignals = [{
  icon: Truck,
  title: "Chrome 浏览器",
  description: "针对 Chrome 引擎深度优化，为您提供最灵敏的 AI 语音识别与逐句精听体验。"
}, {
  icon: ShieldCheck,
  title: "Safari 浏览器",
  description: "完美适配苹果生态，在 Safari 浏览器中享受低功耗、高效率的英语学习之旅。"
}, {
  icon: Award,
  title: "Edge 浏览器",
  description: "全面兼容 Microsoft Edge，支持跨平台插件联动，让您的学习进度时刻保持同步。"
}];
export default function WaaromKoopmeester() {
  return <section data-section-id="109473" id="浏览器支持说明" className="bg-background dark:bg-background/50 py-16 md:py-24 border-t border-border/40">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="sr-only">针对现代浏览器优化</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 max-w-5xl mx-auto">
          {trustSignals.map((signal, i) => {
          const Icon = signal.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center group">
                <div className="mb-6 p-5 rounded-3xl bg-card shadow-xl border border-border/50 transition-all duration-300 group-hover:-translate-y-2 group-hover:shadow-2xl">
                  <Icon className="w-10 h-10 text-secondary" strokeWidth={2} aria-hidden="true" />
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-foreground mb-3 tracking-tight">
                  {signal.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed max-w-[280px] font-medium">
                  {signal.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}